module.exports = __webpack_public_path__ + "rosterv3_player_01-bg.c2a9b13caeaea10c667c.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/assets/images/soccer/rosterv3_player_01-bg.png
// module id = ../../../../../src/assets/images/soccer/rosterv3_player_01-bg.png
// module chunks = styles